import type { AbstractControl } from '@angular/forms';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

/**
 * Map the first validation error on a control to an i18n key.
 * Shared by every `mat-*` Formly field type so errors render the
 * same message in the same voice across the form.
 *
 * `marker()` is a no-op at runtime — it exists so the translation
 * extractor (`@vendure/ngx-translate-extract`) picks these literals
 * up from TypeScript, since they never appear verbatim in a template.
 */
const MSG_REQUIRED = _('This field is required');
const MSG_EMAIL = _('Please enter a valid email');
const MSG_MINLENGTH = _('Value is too short');
const MSG_MAXLENGTH = _('Value is too long');
const MSG_MIN = _('Value is below minimum');
const MSG_MAX = _('Value is above maximum');
const MSG_PATTERN = _('Invalid format');
const MSG_INVALID_DATE = _('Invalid date');
const MSG_DATE_EARLY = _('Date is too early');
const MSG_DATE_LATE = _('Date is too late');
const MSG_INVALID = _('Invalid value');

export function firstErrorMessage(control: AbstractControl | null | undefined): string {
  const errs = control?.errors ?? {};
  if (errs['required']) return MSG_REQUIRED;
  if (errs['email']) return MSG_EMAIL;
  if (errs['minlength']) return MSG_MINLENGTH;
  if (errs['maxlength']) return MSG_MAXLENGTH;
  if (errs['min']) return MSG_MIN;
  if (errs['max']) return MSG_MAX;
  if (errs['pattern']) return MSG_PATTERN;
  if (errs['matDatepickerParse']) return MSG_INVALID_DATE;
  if (errs['matDatepickerMin']) return MSG_DATE_EARLY;
  if (errs['matDatepickerMax']) return MSG_DATE_LATE;
  return MSG_INVALID;
}
